// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReactModal__Content.ReactModal__Content--after-open{\n    padding: 0;\n}\n\n\n.ReactCrop__image{\n    max-height: 300px !important;\n    width: 100%;\n    background-position: center;\n    background-size: cover;\n}\n\n\n.modal-styling {\n    left: 0 !important;\n    padding: 0 !important;\n    right: 0 !important;\n    width: 100%;\n    height: 100%;\n    overflow: scroll;\n}", ""]);
// Exports
module.exports = exports;
